function getEntry(ctx, endpoint, input, options, createMap = false) {
  let entriesForResource = ctx.cache.entries.get(endpoint);
  const key = options.stringifyInput(input);
  if (entriesForResource === undefined) {
    if (createMap) {
      entriesForResource = new Map();
      ctx.cache.entries.set(endpoint, entriesForResource);
    }
    return undefined;
  }
  return entriesForResource.get(key);
}

export default getEntry;
